import React from 'react'

import './Icon.css'

export default function Icon ({ name }) {
  // https://freeicons.io/icon-list/material-icons-action-2?page=1
  const icons = [
    {
      name: 'Error',
      icon: 'type-error'
    },
    {
      name: 'Incidente',
      icon: 'type-incidente'
    },
    {
      name: 'Mantenimiento',
      icon: 'type-mantenimiento'
    },
    {
      name: 'Por hacer',
      icon: 'status-todo'
    },
    {
      name: 'En progreso',
      icon: 'status-in-progress'
    },
    {
      name: 'Listo',
      icon: 'status-done'
    },
    {
      name: 'Crítica',
      icon: 'priority-critical'
    },
    {
      name: 'Alta',
      icon: 'priority-high'
    },
    {
      name: 'Media',
      icon: 'priority-medium'
    },
    {
      name: 'Baja',
      icon: 'priority-low'
    }
  ]

  const iconUrl = (name) => {
    // console.log('Icon name', name)
    const iconSelected = icons.filter(i => i.name === name)[0]
    // console.log('Icon object', iconSelected);
    const iconUrl = `/img/${iconSelected?.icon ? iconSelected.icon : 'default'}.svg`
    // console.log(iconUrl)
    return iconUrl
  }

  return (
    <div className='Icon'>
      <img src={iconUrl(name)} alt={name} />
      <span>{name}</span>
    </div>
  )
}
